import { useContext } from "react";

import { ApiContext } from "../contexts/ApiContext";

export function useJsonApi() {
  return useContext(ApiContext).jsonApi;
}
